import { render, staticRenderFns } from "./ReciveIcon.vue?vue&type=template&id=529da455&"
import script from "./ReciveIcon.vue?vue&type=script&lang=js&"
export * from "./ReciveIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports